/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsSliderData } from './hosports-slider.data';
import { IHosportsSliderProps } from './hosports-slider.props.autogenerated';

export interface IHosportsSliderViewProps extends IHosportsSliderProps<IHosportsSliderData> {

}

/**
 *
 * HosportsSlider component
 * @extends {React.PureComponent<IHosportsSliderProps<IHosportsSliderData>>}
 */
class HosportsSlider extends React.PureComponent<IHosportsSliderProps<IHosportsSliderData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsSlider;
